import { AUDIT_ENTITIES, AUDIT_SCOPES } from '@steado/admin-contract/activity';
import { z } from 'zod';

/**
 * Every filter lives in the URL, which is the point of this screen: "everything
 * that happened to this food", "everything Neha did last Tuesday" and "every
 * health reveal" are all links.
 *
 * `action` and `entity` are free strings rather than enums — the table already
 * holds action names this build has never heard of, and pinning them here would
 * make an entry unfindable the moment a new writer lands.
 */
export const activitySearchSchema = z.object({
  action: z.string().trim().min(1).max(64).optional().catch(undefined),
  entity: z.string().trim().min(1).max(64).optional().catch(undefined),
  entityId: z.string().trim().min(1).max(64).optional().catch(undefined),
  actorUserId: z.string().uuid().optional().catch(undefined),
  scope: z.enum(AUDIT_SCOPES).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type ActivitySearch = z.infer<typeof activitySearchSchema>;

/** The entities the console records against, for the filter dropdown. */
export const ENTITY_OPTIONS = AUDIT_ENTITIES;
